const CUSTOMER = {
  GET_CUSTOMERS: 'GET_CUSTOMERS',
  GET_CUSTOMERS_SUCCESS: 'GET_CUSTOMERS_SUCCESS',
  UPDATE_PAGINATION: 'UPDATE_PAGINATION',
  GET_CUSTOMER_USERS: 'GET_CUSTOMER_USERS',
  GET_CUSTOMER_USERS_SUCCESS: 'GET_CUSTOMER_USERS_SUCCESS',
  LOAD_MORE_CUSTOMER_USERS_SUCCESS: 'LOAD_MORE_CUSTOMER_USERS_SUCCESS',
  GET_CUSTOMER_USERS_FAILURE: 'GET_CUSTOMER_USERS_FAILURE',
  GET_CUSTOMERS_FAILURE: 'GET_CUSTOMERS_FAILURE',
  GET_ACTIVATION_KEY_DETAILS: 'GET_ACTIVATION_KEY_DETAILS',
  GET_ACTIVATION_KEY_DETAILS_SUCCESS: 'GET_ACTIVATION_KEY_DETAILS_SUCCESS',
  RESET_CUSTOMER_DATA: 'RESET_CUSTOMER_DATA',
  GET_ONLINE_CUSTOMERS: 'GET_ONLINE_CUSTOMERS',
  GET_ONLINE_CUSTOMERS_SUCCESS: 'GET_ONLINE_CUSTOMERS_SUCCESS',
  GET_ONLINE_CUSTOMERS_FAILURE: 'GET_ONLINE_CUSTOMERS_FAILURE',
}

export { CUSTOMER }
